import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Place } from '../Places';
import { IFacet } from './Facets.types';

@Identifiable
@Timestampable
@Untrackable
export class Facet extends AbstractDocument<IFacet> {
  readonly collections = {};
}

export class Facets extends AbstractCollection<Facet, IFacet> {
  static path = 'facets';

  constructor(document: Place) {
    super(document.collection(Facets.path), Facet);
  }
}
